/**
 * Custom JavaScript for Sparrowfelt theme
 * 
 * Add your custom JavaScript here
 */

(function($) {
    'use strict';
    
    // Custom theme functionality
    $(document).ready(function() {
        
        // Add your custom JavaScript code here
        console.log('Sparrowfelt theme JavaScript loaded!!');
        
    });
    
})(jQuery);